export default {
  LOADING: Symbol('LOADING'),
  LOADED: Symbol('LOADED'),
  ERROR: Symbol('ERROR'),
  NOT_LOADED: Symbol('NOT_LOADED'),
};
